/** Versión visible del sistema (toolbar y novedades). */
export default '5.2.123'
